<template>
  <div id="category" class="category">
    <p>Category: {{ $route.params.categorySlug }}</p>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import db from '../firebaseInit';
import find from 'lodash/find';
import {CATEGORIES} from './../constants/globalConstants';

export default {
  name: 'Category',
  title: 'Category',
  data() {
    return {
      categoryColor: '',
      categoryConstant: '',
      categoryCssModifier: '',
      categoryDisplayName: '',
      categoryFound: false,
    };
  },
  created() {
    const categorySlug = this.$route.params.categorySlug;
    const categoryObj = find(this.categories, {SLUG: this.$route.params.categorySlug});
    this.categoryFound = categoryObj ? true : false;
    if (this.categoryFound) {
      this.categoryColor = categoryObj.COLOR;
      this.categoryConstant = categoryObj.CONSTANT;
      this.categoryCssModifier = categoryObj.CSS_MODIFIER;
      this.categoryDisplayName = categoryObj.DISPLAY_NAME;
      this.$store.dispatch('SET_CURRENT_CATEGORY_ACTION', {currentCategory: this.categoryConstant});
    }
  },
  methods: {},
  computed: {
    categories: function() {
      return CATEGORIES;
    },
  },
};
</script>

<style lang="scss" scoped></style>
